var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8002_41026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50131 1.6328C-0.384688 3.5918 0.00131207 5.6728 0.00131207 11.9948C0.00131207 18.3308 -0.156688 19.4938 0.603312 21.0698C1.23831 22.3878 2.45131 23.3778 3.87931 23.7468C5.02331 24.0408 5.78331 23.9998 11.9793 23.9998C17.1733 23.9998 18.7893 24.0928 20.1363 23.7448C22.1323 23.2298 23.7563 21.6108 23.9783 18.7878C24.0093 18.3938 24.0093 5.6028 23.9773 5.2008C23.7413 2.1938 21.8903 0.460802 19.4513 0.109802C18.8913 0.0288023 18.7793 0.00480225 15.9113 -0.000197746C5.73831 0.00480225 3.50831 -0.448198 1.50131 1.6328Z",
    fill: "url(#paint0_linear_8002_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9978 3.13892C8.36681 3.13892 4.91881 2.81592 3.60181 6.19592C3.05781 7.59192 3.13681 9.40492 3.13681 12.0009C3.13681 14.2789 3.06381 16.4199 3.60181 17.8049C4.91581 21.1869 8.39181 20.8629 11.9958 20.8629C15.4728 20.8629 19.0578 21.2249 20.3908 17.8049C20.9358 16.3949 20.8558 14.6089 20.8558 12.0009C20.8558 8.53892 21.0468 6.30392 19.3678 4.62592C17.6678 2.92592 15.3688 3.13892 11.9938 3.13892H11.9978ZM11.2038 4.73592C15.5498 4.72892 19.0148 4.12892 19.2098 8.41892C19.2818 10.0079 19.2818 13.9899 19.2098 15.5789C19.0208 19.7159 15.8708 19.2619 11.9988 19.2619C8.58681 19.2619 6.89481 19.3829 5.75481 18.2419C4.59781 17.0849 4.73581 15.4309 4.73581 11.9969C4.73581 7.92592 4.35081 4.97092 8.41881 4.78392C9.23581 4.74692 9.55281 4.73592 11.2038 4.73392V4.73592ZM16.7278 6.20692C16.1408 6.20692 15.6648 6.68292 15.6648 7.26992C15.6648 7.85692 16.1408 8.33292 16.7278 8.33292C17.3148 8.33292 17.7908 7.85692 17.7908 7.26992C17.7908 6.68292 17.3148 6.20692 16.7278 6.20692ZM11.9978 7.44992C9.48481 7.44992 7.44781 9.48792 7.44781 12.0009C7.44781 14.5139 9.48481 16.5509 11.9978 16.5509C14.5108 16.5509 16.5468 14.5139 16.5468 12.0009C16.5468 9.48792 14.5108 7.44992 11.9978 7.44992ZM11.9978 9.04692C13.6288 9.04692 14.9508 10.3699 14.9508 12.0009C14.9508 13.6319 13.6288 14.9549 11.9978 14.9549C10.3668 14.9549 9.04481 13.6319 9.04481 12.0009C9.04481 10.3689 10.3668 9.04692 11.9978 9.04692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8002_41026",
    x1: 1.56588,
    y1: 22.4431,
    x2: 23.8438,
    y2: 3.16101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8002_41026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmInstagram);
export default __webpack_public_path__ + "static/media/crm-instagram.db86e714ce8f118f5bf33a05fa866898.svg";
export { ForwardRef as ReactComponent };